
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  commonModule,
  appointmentsModule,
  actionTypesModule,
  installationsModule,
  itemsModule,
  itemTypesModule,
  companyModule,
  appointmentsRecurrencesModule,
} from "@/store/modules/store-accessor";
import { isDecimalNumber, getOptimalTextColor, isNumber, timeChargedUnitLabels, calculateTimeChargingCost, calcDuration, installationPhotoCompressionSettings, paymentClientsOptions } from "@/helpers/data";
import AssigneeUserCombo from "@/components/Combobox/AssigneeUserCombo.vue";
import LabelCombo from '@/components/Combobox/LabelCombo.vue';
import PaymentAllocation from '@/components/Payments/PaymentAllocation.vue';
import _ from "lodash";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import imageCompression from 'browser-image-compression';
import { greekSearchFilter } from "@/helpers/data";

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  components: {
    AssigneeUserCombo,
    LabelCombo,
    PaymentAllocation,
  },
})
export default class EndAppointmentModal extends Vue {
  @Prop()
  payload!: any;

  isEndingAppointment = false;
  addMaterials = false;
  payloadAssignee = {} as any;
  addExpenses = false;
  installationItem = "";

  scheduledAtDateMenu = false;
  scheduledAtTimeMenu = false;

  greekSearchFilter = greekSearchFilter;

  jobModel = {
    type_id: [] as any[],
    materials: [
      {
        id: Math.random() * -1, //Need Random and non-integer and also negative, for this to work with the backend properly
        cost: 0, //This needs to be initialized not null for the reduce to work
        description: "",
        notes: "",
        unit_quantity: '1',
        unit_cost: 0,
        unit: null,
        inventory_item_id: null,
      },
    ] as any,
    assignee_id: this.getAssigneeId(this.payload.appointment.assignee_id),
    installation_id: this.payload.installation.info
      ? this.payload.installation.info.id
      : this.payload.appointment.installation_id,
    is_complete: false,
    notes: this.payload.appointment.job_notes || "",
    payment_amount: null,
    is_paid: false,
    radioValue: "user",
    id: this.payload.appointment.id,
    job_id: this.payload.appointment.job_id,
    payment_type: this.paymentTypesCombo[0],
    installation_item_id: this.payload.appointment.installation_item_id,
    item_type_text: this.payload.appointment.item_type_text,
    item_make: this.payload.appointment.item_make,
    item_model: this.payload.appointment.item_model,
    item_serial_no: this.payload.appointment.item_serial_no,
    expenses: [
      {
        id: Math.random() * -1, //Need Random and non-integer and also negative, for this to work with the backend properly
        cost: 0,
        notes: "",
        expense_label_id: null,
      },
    ] as any,
    job_description: this.payload.appointment.job_description || "",
    scheduled_start_date: dayjs(this.setScheduledStartVariable).format('YYYY-MM-DD'),
    scheduled_start_time: dayjs(this.setScheduledStartVariable).format('HH:mm'),
    duration: {},
    actual_start: '',
    payments: [
      {
        id: Math.random() * -1, // Need Random and non-integer and also negative, for this to work with the backend properly
        amount: 0, // This needs to be initialized not null for the reduce to work
        payment_type: this.paymentTypesCombo[0],
        notes: '',
        client_paid: this.paymentPersonOptions[0],
    }] as any,
    is_virtual: this.payload.appointment.is_virtual,
    recurrence_id: this.payload.appointment.recurrence_id,
  };

  photoModel = {
    add_photo: false,
    photos: [] as File[],
    notes: '',
    urls: [] as string[],
    previewUrls: [] as string[],
  };

  typeRule = [
    (val: any) => (val || "").length > 0 || this.$i18n.t("actions_required"),
  ];
  userRule = [(val: any) => !!val || this.$i18n.t("user_required")];
  notesRule = [
    (val: any) => {
      if (val != null)
        return val.length <= 1000 || this.$i18n.t("form_notes_length_rule");
      else return true;
    },
  ];
  expenseNotesRule = [
    (val: any) => {
      if (val != null)
        return val.length <= 30 || this.$i18n.t("expenseNotesLengthRule");
    },
  ];
  materialNotesRule = [
    (val: any) => {
      if (val != null)
        return val.length <= 1000 || this.$i18n.t("notesLengthRule");
      else return true;
    },
  ];
  actionNotesRule = [
    (val: any) => {
      if (val != null)
        return val.length <= 1000 || this.$i18n.t("notesLengthRule");
      else return true;
    },
  ];
  paymentTypeRule = [
    (val: any) => (val || "").id > 0 || this.$i18n.t("payment_type_required"),
  ];
  photoRules = [
    (val: any) => val && val.length >= 1 || this.$t("photosRequired"),
    (val: any) => val && val.length <= 30 || this.$t('photoLengthRule'),
  ];
  photoNotesRule = [
    (val: any) => val.length <= 50 || this.$i18n.t("notesForPhotoRule"),
  ];
  costRule: any = [
    (val: any) => (val !== "" && val >= 0) || this.$i18n.t("cost_required"),
  ];
  descriptionRule = [
    (val: any) =>
      val == null ||
      val?.text?.length <= 80 ||
      val?.length <= 80 ||
      this.$i18n.t("client_form_description_length_rule"),
  ];
  jobDescriptionRule = [
    (val: any) =>
      val.length <= 80 || this.$i18n.t("installationDescriptionLengthRule"),
  ];
  scheduledDateRule = [
    (val: any) => !!val || this.$i18n.t("jobScheduledDayRequired"),
  ];

  itemUnitCostRule = [
    (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t("requiredRule"),
  ]
  durationRule = [(val: any) => !!val || this.$i18n.t("duration_required")];

  scheduledTimeRule = [(val: any) => !!val || this.$i18n.t("scheduled_time_required")];

  itemUnitQuantityRules(index: number) {
    return [
      (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t("requiredRule"),
      (val: any) => {
        const currentMaterial = this.jobModel?.materials[index];
        if (currentMaterial && currentMaterial?.unit.enum_text === 'PIECES') {
          const valToString = String(val);
          if (valToString.includes('.') || valToString.includes(',')) {
            return this.$i18n.t("itemUnitPiecesDecimalWarning");
          }
        }
        return true;
      }
    ];
  }

  itemUnitRule = [
    (val: any) => ((!!val || val == '') && val.text.length > 0) || this.$i18n.t("unitOptionRule"),
  ]

  nextEventRule = [(val: any) => !!val || this.$i18n.t("nextEventRuleText")];

  reminderRule = [
    (val: any) => (val !== "" && val >= 0) || this.$i18n.t("reminderRuleText"),
  ];

  reminderOptionRule = [
    (val: any) =>
      ((!!val || val == "") && val.text.length > 0) ||
      this.$i18n.t("reminderOptionRuleText"),
  ];

  unitOptionRule = [
    (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t("requiredRule"),
  ]

  unitRule = [
    (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t("requiredRule"),
  ]

  unitQuantityRule = [
    (val: any) => ((!!val || val == '') && val.text.length > 0) || this.$i18n.t("unitOptionRule"),
  ]

  get periodicCombo() {
    return commonModule.periodicCombo;
  }

  get installationPrimaryItems() {
    return itemsModule.installationPrimaryItems;
  }

  get isLoadingItems() {
    return itemsModule.loadingItemsCombo;
  }

  get itemsUnitsTypes() {
    return itemsModule.itemsUnitsCombo;
  }

  get inventoryItemsCombo () {
    return commonModule.inventoryItemsCombo;
  }

  get jobTotalCost() {
    let actionTotal = this.jobModel.type_id?.reduce(
      (accumulator: number, item: any) => {
        return (
          accumulator +
          (!isNaN(parseFloat(item.cost)) ? parseFloat(item.cost) : 0)
        );
      },
      0
    );
    let materialTotal = this.jobModel.materials?.reduce(
      (accumulator: number, item: any) => {
        return (
          accumulator +
          (!isNaN(parseFloat(item.cost)) ? parseFloat(item.cost) : 0)
        );
      },
      0
    );

    let total = actionTotal;

    if (this.addMaterials) total += materialTotal;

    return total;
  }

  actualCostRule: any = [];

  get actionsCombo() {
    return actionTypesModule.actionTypesCombo;
  }

  get assigneeIdCombo() {
    return commonModule.personnelCombo;
  }

  get paymentTypesCombo() {
    for (let i = 0; i < commonModule.paymentTypeCombo.length; i++) {
      (commonModule.paymentTypeCombo[i]["payment_type"] as any) = this.$t(
        commonModule.paymentTypeCombo[i]["payment_type"]
      );
    }
    return commonModule.paymentTypeCombo;
  }

  get itemTypesCombo() {
    return itemTypesModule.itemTypesCombo;
  }

  get timeChargedUnitCombo() {
    return commonModule.timeChargedUnitCombo;
  }

  onlyNumbers(evt: any) {
    isNumber(evt);
  }

  async hideModal() {
    commonModule.hideModal();
  }

  findActionType(appointment: any) {
    let combo: any = actionTypesModule.actionTypesCombo;
    const foundType = combo.find(
      (item: any) => item.id === appointment.action_type_id
    );
    if (foundType) {
      return [
        {
          text: foundType.text,
          color: foundType.color,
          cost: foundType.cost,
          id: foundType.id,
          is_periodic: foundType.is_periodic,
          next_task: foundType.next_task,
          reminder_option_value: foundType.reminder_option_value,
          reminder_option_combo: foundType.reminder_option_combo,
          is_time_charged: foundType.is_time_charged,
          unit: foundType.unit,
          unit_cost: foundType.unit_cost,
          unit_quantity: foundType.unit_quantity
        },
      ] as any;
    } else {
      return [] as any;
    }
  }

  getAssigneeId(name: string) {
    const combo: any = commonModule.personnelCombo;
    const foundItem = combo.find((item: any) => item.name === name);
    if (foundItem) {
      return { name: foundItem.name, id: foundItem.id };
    } else {
      return "";
    }
  }
  optimalTextColor(color: string) {
    return getOptimalTextColor(color);
  }

  async beforeMount() {
    await itemsModule.getInstallationPrimaryInventoryItems(
      this.jobModel.installation_id
    );

    this.jobModel.duration = {
      dur: this.durationFound(
        calcDuration(this.setScheduledStartEndVariables[0], this.setScheduledStartEndVariables[1])),
      text: this.textFound(
        calcDuration(this.setScheduledStartEndVariables[0], this.setScheduledStartEndVariables[1]))
        ? calcDuration(this.setScheduledStartEndVariables[0], this.setScheduledStartEndVariables[1])
        : '',
    };
  }

  async mounted() {
    await actionTypesModule.getActionTypesCombo();
    this.jobModel.type_id = this.findActionType(this.payload.appointment);

    this.installationItem = this.itemName({
      primary_items: this.payload.appointment.job_item,
      id: this.payload.appointment.installation_item_id,
      item_description: this.payload.appointment.item_description,
    });
    this.payloadAssignee = this.getAssigneeId(
      this.payload.appointment.assignee_id
    );
    if (this.jobModel.type_id[0]) {
      this.calculateTimeChargingCost(this.jobModel.type_id[0], true);
    }
    commonModule.initSnackbar({});
    await commonModule.getPersonnelCombo();
    await commonModule.getPaymentTypeCombo();
    this.jobModel.payment_type = this.paymentTypesCombo[0];
    await itemTypesModule.getItemTypesCombo();
    await itemsModule.getAllInventoryItems("");
    await commonModule.getPeriodicCombo(1);
    await commonModule.getTimeChargedUnitCombo();
    await itemsModule.getItemsUnitsCombo();
    await commonModule.getDurationCombo();
    await commonModule.getItemsCombo();
    await commonModule.getExpenseLabelsCombo();
  }

  updateAssignee(assignee: any) {
    if (assignee) {
      this.jobModel.assignee_id = assignee;
    }
  }

  addPhoto() {
    commonModule.showModal({
      name: "add-photo-to-installation-modal",
      payload: { installation: this.jobModel, tab: "closeAppointment" },
    });
  }

  async PreviewPhotos() {
    if (Array.isArray(this.photoModel.photos)) {
      const compressedFiles = [];
      const newPhotosPreview = [];

      for (const file of this.photoModel.photos) {
        try {
          const options = installationPhotoCompressionSettings();
          const compressedFile = await imageCompression(file, options);
          compressedFiles.push(compressedFile);
          newPhotosPreview.push(URL.createObjectURL(compressedFile));
        } catch (error) {
          newPhotosPreview.push('');
        }
      }

      this.photoModel.photos = compressedFiles;
      this.photoModel.previewUrls = newPhotosPreview;
    }
  }

  repayment() {
    const remainingAmount = Number(this.jobTotalCost) - this.paymentsTotal;

    const lastPaymentIndex = this.jobModel.payments.length - 1;
    const lastPaymentAmount = Number(this.jobModel.payments[lastPaymentIndex].amount || 0);

    if (lastPaymentAmount === 0) {
      this.jobModel.payments[lastPaymentIndex].amount = remainingAmount;
      this.$nextTick(() => this.validatePaymentAmounts());
      return;
    }

    this.jobModel.payments.push({
      id: Math.random() * -1, // Need Random and non-integer and also negative, for this to work with the backend properly
      amount: remainingAmount,
      payment_type: this.paymentTypesCombo[0],
      notes: '',
      client_paid: this.paymentPersonOptions[0],
    });
    this.$nextTick(() => this.validatePaymentAmounts());
  }

  validatePaymentAmounts() {
    this.jobModel.payments.forEach((_: Record<string, any>, index: number) => {
      const ref = this.$refs[`paymentAmount_${index}`];
      const field = Array.isArray(ref) ? ref[0] : ref;
      if (field && typeof (field as Record<string, any>).validate === 'function') {
        (field as Record<string, any>).validate();
      }
    });
  }

  addMaterial() {
    let newMaterial = {
      id: Math.random() * -1,
      cost: 0, //This needs to be initialized not null for the reduce to work
      description: "",
      notes: "",
      unit_quantity: '1',
      unit_cost: 0,
      unit: null,
      inventory_item_id: null,
    } as any;

    this.jobModel.materials.push(newMaterial);
    this.$nextTick(() => this.validatePaymentAmounts());
  }

  deleteMaterial(index: number) {
    if (this.jobModel.materials.length > 1) {
      this.jobModel.materials.splice(index, 1);
      this.$nextTick(() => this.validatePaymentAmounts());
    }
  }

  addExpense() {
    let newExpense = {
      id: Math.random() * -1,
      cost: 0,
      notes: "",
      expense_label_id: null,
    } as any;

    this.jobModel.expenses.push(newExpense);
    this.$nextTick(() => this.validatePaymentAmounts());
  }

  deleteExpense(index: number) {
    if (this.jobModel.expenses.length > 1) {
      this.jobModel.expenses.splice(index, 1);
      this.$nextTick(() => this.validatePaymentAmounts());
    }
  }

  async doEndAppointment() {
    const paymentAllocation = this.$refs.paymentAllocation as PaymentAllocation;
    const isPaymentAllocationValid = !this.jobModel.is_paid || (!!paymentAllocation && paymentAllocation.validate());

    if ((this.$refs.form as Vue & { validate: () => boolean }).validate() && isPaymentAllocationValid) {
      this.isEndingAppointment = true;
      let job = _.cloneDeep(this.jobModel);
      const companyTimezone = companyModule.company?.timezone || dayjs.tz.guess();

      if (this.photoModel.add_photo && this.photoModel.photos.length > 0) {
        const formData = new FormData();
        for (const file of this.photoModel.photos) {
          formData.append('image', file);
        }
        formData.append('notes', this.photoModel.notes);
        formData.append("job_id", job.job_id);
        installationsModule.addInstallationPhoto({
          installationId: job.installation_id,
          photo: formData,
        });
      }

      // Set actual_start only if the duration field is shown
      if(this.showDurationField) {
        job.actual_start = dayjs(job.scheduled_start_date + ' ' + job.scheduled_start_time).toISOString();
      }

      if (this.addMaterials) {
        job.materials = job.materials.map((material: any) => {
          if (
            typeof material.description === "object" &&
            material.description != null
          ) {
            material.description = material.description.text;
            material.unit = material.unit.enum_text
            return material;
          } else {
            return material;
          }
        });
      } else {
        delete job.materials;
      }

      job.type_id.map((item: any) => {
        item.due_at = item.is_periodic
          ? dayjs
              .tz(item.next_task, companyTimezone)
              .startOf("day")
              .subtract(
                parseInt(item.reminder_option_value) *
                  item.reminder_option_combo.period,
                "days"
              )
              .endOf("day")
              .toISOString()
          : null;
      });

      if (!this.addExpenses) {
        delete job.expenses;
      }

      try {
        if(job.is_virtual) {
          await appointmentsRecurrencesModule.endRecurringAppointment(job);
        } else {
          await appointmentsModule.endAppointment(job);
        }
        appointmentsModule.getCalendarAppointmentsAction(appointmentsModule.filters).catch(() => undefined);
        await installationsModule.getInstallationDetailsAppointments(job.installation_id);
        this.hideModal();
      } finally {
        this.isEndingAppointment = false;
      }
    }
  }
  onlyDecimalNumbers(evt: any) {
    isDecimalNumber(evt);
  }

  get jobDescriptionIsEnabled() {
    return (companyModule.company?.preferences as any)?.job_description;
  }

  itemName(obj: any) {
    const installationItemDescriptionIsEnabled = (companyModule.company?.preferences as any)?.installation_item_description;
    if(installationItemDescriptionIsEnabled) {
      obj = { ...obj, primary_items: `${obj.item_description ? obj.item_description + ' | ' : ''}${obj.primary_items}`}
    }
    const combo: any = this.installationPrimaryItems;
    const foundItem = combo.find(
      (item: any) =>
        item.id === obj.id && item.primary_items[0] == obj.primary_items
    );
    if (foundItem) {
      return foundItem.primary_items[0];
    } else {
      if (obj.id) {
        let item_hidden_id = (Math.random() + 1).toString(36).substring(7);
        this.installationPrimaryItems.push({
          ...obj,
          disabled: true,
          hidden_id: item_hidden_id,
        });
        return obj.primary_items;
      } else {
        return "-";
      }
    }
  }

  calculateTimeChargingCost(action: Record<string, any>, initialCalc = false) {
    action.scheduled_start = this.payload.appointment.scheduled_start;
    action.scheduled_end = this.payload.appointment.scheduled_end;
    const result = calculateTimeChargingCost(action, initialCalc);
    if (!initialCalc) {
      this.$nextTick(() => this.validatePaymentAmounts());
    }
    return result;
  }

  timeChargedUnitLabels(unit: Record<string, any>) {
    return timeChargedUnitLabels(unit?.unit);
  }

  itemUnitNumberInputs(evt: Record<string,any>, item: Record<string, any>) {
    if(item.unit.decimals) {
      return isDecimalNumber(evt);
    }
    return isNumber(evt)
  }

  findItemUnit(unitType: Record<string, any>, index: number, material: Record<string, any>) {
    let unitCombo: any = itemsModule.itemsUnitsCombo;
    const foundUnitType = (unitCombo).find((item: any) => item.enum_text == unitType.unit);
    material.unit = { text: foundUnitType?.text, enum_text: foundUnitType?.enum_text, decimals: foundUnitType?.decimals } as any;
    material.is_unit_based = unitType.is_unit_based ?? false;
    material.unit_cost = unitType.cost ?? null;
    material.cost = unitType.cost ?? 0;
    material.unit_quantity = unitType.is_unit_based ? 1 : null;
    material.inventory_item_id = unitType.inventory_item_id ?? null;
  }

  calcItemUnitCost(index: number) {
    this.jobModel.materials[index].cost = (this.jobModel.materials[index].unit_cost * this.jobModel.materials[index].unit_quantity).toFixed(2);
    this.$nextTick(() => this.validatePaymentAmounts());
  }

  get durationCombo() {
    return commonModule.durationCombo;
  }

  textFound(duration: string) {
    const found = commonModule.durationCombo?.find((item: any) => {
      return item.text === duration;
    });
    return found == undefined ? false : true;
  }

  durationFound(duration: string) {
    const found: any = commonModule.durationCombo?.find((item: any) => {
      return item.text === duration;
    });
    return found == undefined ? "" : found.dur;
  }

  get showDurationField() {
    return (companyModule.company?.preferences as any)?.end_appointment_show_duration;
  }

  get setScheduledStartVariable() {
    if(this.payload.appointment.actual_start) {
      return this.payload.appointment.actual_start;
    }
    if(this.payload.appointment.realStartDateTime) { // complete from calendar button
      return this.payload.appointment.realStartDateTime;
    }
    return this.payload.appointment.scheduled_start;
  }

  get setScheduledStartEndVariables() { // in order to find the duration
    if(this.payload.appointment.scheduled_start && this.payload.appointment.scheduled_end) {
      return [this.payload.appointment.scheduled_start, this.payload.appointment.scheduled_end];
    }
    return [this.payload.appointment.realStartDateTime, this.payload.appointment.realEndDateTime];
  }

  addPayment() {
    let newPayment = {
      id: Math.random() * -1, // Need Random and non-integer and also negative, for this to work with the backend properly
      amount: 0, // This needs to be initialized not null for the reduce to work
      payment_type: this.paymentTypesCombo[0],
      notes: '',
      client_paid: this.paymentPersonOptions[0],
    } as any

    this.jobModel.payments.push(newPayment);
    this.$nextTick(() => this.validatePaymentAmounts());
  }

  deletePayment(index: number) {
    if (this.jobModel.payments.length > 1) {
      this.jobModel.payments.splice(index, 1);
      this.$nextTick(() => this.validatePaymentAmounts());
    }
  }

  get paymentPersonOptions() {
    return paymentClientsOptions(this.payload);
  }

  get paymentClientsCombo() {
    return this.paymentPersonOptions.map((client: Record<string, any>) => ({
      id: client.value === 'user' ? this.payload.installation.info.user_id : this.payload.installation.info.owner_id,
      name: client.label,
      is_business: client.value === 'user' ? this.payload.installation.info.client_is_business : this.payload.installation.info.owner_is_business,
    }));
  }

  updatePayments(payments: JobPaymentRequestDto[]) {
    this.jobModel.payments = payments as any;
  }

  get paymentsTotal() {
    return this.jobModel.payments.reduce((sum: number, payment: Record<string, any>) => sum + Number(payment.amount), 0);
  }

  get enableRepayment() {
    return Number(this.jobTotalCost) > 0 && Number(this.jobTotalCost) > Number(this.paymentsTotal);
  }

  get paymentRule() {
    return [
      (val: any) => {
        if (val === "" || isNaN(val)) {
          return this.$i18n.t("nonZeroPaymentRule");
        }
        return val > 0 || this.$i18n.t("nonZeroPaymentRule");
      },
      (val: any) => {
        return this.paymentsTotal <= this.jobTotalCost || this.$i18n.t("actualCostRule");
      },
    ];
  }

  updateLabel(index: number, label: any) {
    this.jobModel.expenses[index].expense_label_id = label;
  }

  get expenseLabelsCombo() {
    return commonModule.expenseLabelsCombo;
  }

};
